module.exports = __webpack_public_path__ + "fonts/montserrat-latin-100-normal.2fa5a79.woff2";